import React, { useEffect, useState } from 'react';
import { teacherApi } from '../../api/client';
import { useAuth } from '../../context/AuthContext';
import Spinner from '../../components/common/Spinner';
import Modal from '../../components/common/Modal';
import { FaPlus, FaTrash } from 'react-icons/fa';
import toast from 'react-hot-toast';

const DAYS = ['Monday','Tuesday','Wednesday','Thursday','Friday'];

export default function Timetable() {
  const { user } = useAuth();
  const [slots,    setSlots]    = useState([]);
  const [grades,   setGrades]   = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [modal,    setModal]    = useState(false);
  const [gradeFilter, setGradeFilter] = useState('');
  // teacher_id is auto-filled from the logged-in user — no input needed
  const [form, setForm] = useState({ grade_id:'', subject_id:'', day_of_week:'Monday', start_time:'', end_time:'', room:'' });

  const load = () => teacherApi.getTimetable({}).then(r=>setSlots(r.data.data)).finally(()=>setLoading(false));
  useEffect(()=>{ Promise.all([teacherApi.getGrades(),teacherApi.getSubjects()]).then(([g,s])=>{setGrades(g.data.data);setSubjects(s.data.data);}); load(); },[]);//eslint-disable-line

  const handleSave = async (e) => {
    e.preventDefault();
    // Auto-assign the logged-in teacher's ID
    const payload = { ...form, teacher_id: user?.sub || user?.id };
    try { await teacherApi.addTimetable(payload); toast.success('Slot added'); setModal(false); load(); }
    catch (err) { toast.error(err.response?.data?.message||'Failed'); }
  };

  const filtered = gradeFilter ? slots.filter(s=>String(s.grade_id)===gradeFilter) : slots;
  const byDay = DAYS.reduce((acc,d)=>({ ...acc, [d]: filtered.filter(s=>s.day_of_week===d).sort((a,b)=>a.start_time.localeCompare(b.start_time)) }),{});

  return (
    <div>
      <div className="page-header" style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
        <div><h2>Timetable</h2></div>
        <button className="sms-btn sms-btn-primary" onClick={()=>{setForm({grade_id:'',subject_id:'',day_of_week:'Monday',start_time:'',end_time:'',room:''});setModal(true);}}><FaPlus size={13}/> Add Slot</button>
      </div>

      <div style={{marginBottom:16}}>
        <select className="sms-input" style={{width:200}} value={gradeFilter} onChange={e=>setGradeFilter(e.target.value)}>
          <option value="">All Grades</option>
          {grades.map(g=><option key={g.grade_id} value={g.grade_id}>Grade {g.grade_number}</option>)}
        </select>
      </div>

      {loading ? <Spinner /> : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:12}}>
          {DAYS.map(day=>(
            <div key={day}>
              <div style={{fontWeight:700,fontSize:'0.88rem',color:'#374151',marginBottom:8,textAlign:'center',padding:'8px',background:'#f3f4f6',borderRadius:8}}>{day}</div>
              <div style={{display:'flex',flexDirection:'column',gap:8}}>
                {byDay[day].map(s=>(
                  <div key={s.id} style={{background:'#eff6ff',borderRadius:8,padding:'10px 12px',borderLeft:'3px solid #0d6efd',position:'relative'}}>
                    <div style={{fontWeight:600,fontSize:'0.85rem'}}>{s.subject_name}</div>
                    <div style={{color:'#6b7280',fontSize:'0.75rem'}}>{s.start_time}–{s.end_time}</div>
                    <div style={{color:'#9ca3af',fontSize:'0.72rem'}}>{s.teacher_name}</div>
                    {s.room&&<div style={{color:'#9ca3af',fontSize:'0.72rem'}}>Room: {s.room}</div>}
                    <button onClick={async()=>{if(window.confirm('Delete?')){await teacherApi.deleteTimetable(s.id);toast.success('Deleted');load();}}} style={{position:'absolute',top:6,right:6,background:'none',border:'none',cursor:'pointer',color:'#ef4444',opacity:0.5}}><FaTrash size={10}/></button>
                  </div>
                ))}
                {byDay[day].length===0&&<div style={{textAlign:'center',color:'#d1d5db',fontSize:'0.8rem',padding:'16px 0'}}>—</div>}
              </div>
            </div>
          ))}
        </div>
      )}

      <Modal show={modal} onClose={()=>setModal(false)} title="Add Timetable Slot">
        <form onSubmit={handleSave}>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:0}}>
            <div><label className="sms-label">Grade*</label><select className="sms-input" value={form.grade_id} onChange={e=>setForm({...form,grade_id:e.target.value})} required><option value="">Select</option>{grades.map(g=><option key={g.grade_id} value={g.grade_id}>Grade {g.grade_number}</option>)}</select></div>
            <div><label className="sms-label">Subject*</label><select className="sms-input" value={form.subject_id} onChange={e=>setForm({...form,subject_id:e.target.value})} required><option value="">Select</option>{subjects.filter(s=>!form.grade_id||String(s.grade_id)===form.grade_id).map(s=><option key={s.subject_id} value={s.subject_id}>{s.subject_name}</option>)}</select></div>
            <div><label className="sms-label">Day*</label><select className="sms-input" value={form.day_of_week} onChange={e=>setForm({...form,day_of_week:e.target.value})}>{DAYS.map(d=><option key={d}>{d}</option>)}</select></div>
            <div><label className="sms-label">Room</label><input className="sms-input" value={form.room} onChange={e=>setForm({...form,room:e.target.value})} placeholder="e.g. B12"/></div>
            <div><label className="sms-label">Start Time*</label><input className="sms-input" type="time" value={form.start_time} onChange={e=>setForm({...form,start_time:e.target.value})} required/></div>
            <div><label className="sms-label">End Time*</label><input className="sms-input" type="time" value={form.end_time} onChange={e=>setForm({...form,end_time:e.target.value})} required/></div>
          </div>
          <div style={{display:'flex',gap:10,marginTop:16}}>
            <button type="submit" className="sms-btn sms-btn-primary">Save</button>
            <button type="button" className="sms-btn sms-btn-outline" onClick={()=>setModal(false)}>Cancel</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
